// Self-signed certificate + private key for signing QZ Tray requests.
//
// Purpose: QZ Tray only remembers the Allow decision (and can skip the dialog
// entirely) for SIGNED requests. The frontend signs every QZ request with this
// key; QZ Tray trusts the matching certificate via its override.crt (see
// docs/qz-tray-setup or the deploy notes). Valid until 2036.
//
// Note: this key only authorizes PRINTING through QZ Tray on machines that
// installed the matching override.crt — it protects nothing else. Embedding it
// in the bundle is the standard QZ pattern for internal/LAN apps.

export const QZ_CERTIFICATE = `-----BEGIN CERTIFICATE-----
MIIDXzCCAkegAwIBAgIUGvf+0yTSrbDf6XfWGhEudvU2ifkwDQYJKoZIhvcNAQEL
BQAwPzELMAkGA1UEBhMCSUQxFjAUBgNVBAoMDVN1biBGaXJld29ya3MxGDAWBgNV
BAMMD3Nmd2FyZWhvdXNlLmFwcDAeFw0yNjA3MDMwMzA2MzFaFw0zNjA2MzAwMzA2
MzFaMD8xCzAJBgNVBAYTAklEMRYwFAYDVQQKDA1TdW4gRmlyZXdvcmtzMRgwFgYD
VQQDDA9zZndhcmVob3VzZS5hcHAwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEK
AoIBAQC5pDO9Dv3i8jSyiwY587vCqmK3V/tTbMc3TO25QRbPd7InPiWMiF8mJwv8
rIv9nxnSZ3uIdB7GuX5DHhrMFyBQlYez1BVNG8hbaTeiTFn0fy7h+omuUjDlu9g3
V+oTPFWZWKJCOWk97lhPoAJMDEb6Ydt62fkros6Rdva07N/9TA6CVQJdsXkw1R+c
9/SyR3RdJiTlP3WMyUu2EuoBRKGgpW9kW8nfuNOfTiM7p9tixLz8XT2leKz50KrW
E2ms9CMTd/Y7aFy/EG3eNTxuLKDAzmAvxBmXlt5cf35a11D13iMGarFtlr3wk76y
VooKSaB2eBsJN80iNru7W+pPKCKlAgMBAAGjUzBRMB0GA1UdDgQWBBTVZ479r4mY
hTvzATCazG7SaHMp3zAfBgNVHSMEGDAWgBTVZ479r4mYhTvzATCazG7SaHMp3zAP
BgNVHRMBAf8EBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQBSECFi4Yc05yu4eDrK
bRiBfnNfd/Z74Cenr/mCxqnnZ4B36ENXBqQC5iq9PuPIZS7SZxrU17KbRv9vRQgy
jzBsYYqDimxwpuK/SKkhdLUlAbfXmm5NwPyhMtckfEEVJ0VclGsBeH4/Q6qqcemP
M6Qfh/uCA+WEVthzZpOCa7uHiVV2yddMOpMDPMA3p02UtspfrOa1n3wJgJ9zrK3X
a71ztzgOExwbFS++viwCD0RDZD3TAyKIuM5Tvmsb6lXJXnAZZrAYwCq1lWPEJlTu
LzywSPE3lMYYt/8pzINfJbB8Zs8oky+cjfPIK0PPbhu/hDjgkY+DWsw7J5/XGCpP
KwmI
-----END CERTIFICATE-----`;

export const QZ_PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQC5pDO9Dv3i8jSy
iwY587vCqmK3V/tTbMc3TO25QRbPd7InPiWMiF8mJwv8rIv9nxnSZ3uIdB7GuX5D
HhrMFyBQlYez1BVNG8hbaTeiTFn0fy7h+omuUjDlu9g3V+oTPFWZWKJCOWk97lhP
oAJMDEb6Ydt62fkros6Rdva07N/9TA6CVQJdsXkw1R+c9/SyR3RdJiTlP3WMyUu2
EuoBRKGgpW9kW8nfuNOfTiM7p9tixLz8XT2leKz50KrWE2ms9CMTd/Y7aFy/EG3e
NTxuLKDAzmAvxBmXlt5cf35a11D13iMGarFtlr3wk76yVooKSaB2eBsJN80iNru7
W+pPKCKlAgMBAAECggEALujbvBPcOutKPq2buqwoz3V/sWW1l+yeYI57absVWQKd
jYYKNftF0929DTHKxCFehIjqsd3p4vx/d9VVHype244Vdu8KHOx+0f6B9OyHNJ2o
yqik/tw9B+hSKBX6i7bMyI2ZntNkESa3wRMlUXMuwllU/TO0X37p5N8jUy+iIB6X
RwUtkOczhrPCaFDuT6yBM9ePe5Lk4C59FKYe45DyAGkcnmZZFgNJYEwxyPjWfpSO
Rih3kCaKJ2uCVXWV+8bONXVfcxSkkWMJYEKjcmMK7FPQS9f4qWMgivv+j1mTStjv
7PYADXkPZPOlshsWe0TP3/xkwLo2finQPGkTI/8m1wKBgQD5Tpk8Q9WQTReKwz4D
sw5v1enEtU0UtYyQ7fNt3iuCVoFPngredoJChCYtPlG2S0IxM3xJO9NTIVCTwAc3
IEYCE8YDzkGAIbenfpP+HOUdisRN7bpbcz57qNzOz0Fja5fzQgT3qjFEl8OohyOx
EjSJkRpqATvZcpZTDfmHDQL7ZwKBgQC+oA07HNafv9V2jPw5sFVQ+wILwETblHF6
Q4BspRNU/KFuFkx5uUw31v+k2HNgm7PIlFzR7kUv1IhhNcET8aKO916Us8+gmL8L
SGc9c5D/UE6ujGOgPWAzbY/JfKqIJjNA45YCjMWqmPEQoXWSmrVsJw13UqYtWxRZ
Vsn1bMJ2EwKBgFeELeqn7WpwhZkinLxzuNetghiZhGuGp8egoFmrKh7g+xfV5P7f
Hy72cOhk/g4+MQhQiIq0w6RlB4I2YNILNEg6ZMKlPv0Z2PylRJJp1kwekHbCwy6j
MAX86zZ2LwAVnwu320KNrinkFL0uY2sfdu3r0BfyQu48eWTCfRvZh3h1AoGAMrHz
8tWPinqE9Xs3FMx9VAT9HUzrww2uRBqxi7M2+fIZqGJLwk9yIqON5zQdMwMVg/FY
4geg5MB76IZYK8qmNak5wQg03nvgyspdkm0qkYu08Ryq3hGUhPjNNYNvArhOByK/
YTw40U7NRWP7FZsJRpL4NNSJFyTSu5OmMBvVd3sCgYEAihi+V1NtwMlmh+d9EUk7
VR9Kv3oKvsxGjX3uHpIFZpxR9VUiXaWXdtydcnAeEP1pWFYiVGbLSnJGtj5wLdze
0EDO129e6FQYYDUJHy8lto4YFQop7AMJvhmVFw8KsXFtSQlIP9mYEwZ9CK7TF/Ne
cdlZKO7lzDXOfWnaskpT0v4=
-----END PRIVATE KEY-----`;
